import { compatibleImageProjection, internalReferenceUrl } from './projection';
import { namespaceType } from '../lib/namespace';

const contactSupportType = namespaceType('contactSupport');

const contactSupportImageProjection = compatibleImageProjection({
  alias: 'image',
  imageField: 'image',
  bynderField: 'bynderImage',
  alt: "coalesce(bynderImage.textMetaproperties[name == 'Alt_text'][0].value, bynderImage.alt, image.alt, alt, bynderImage.description, bynderImage.name)",
});

export const CONTACT_SUPPORT_QUERY = `
  *[_id == $docId][0]{
    ...,
    isIncludedContactSupport,
    "contactSupport": select(
      isIncludedContactSupport => *[_type == "${contactSupportType}"][0]{
        ...,
        imageLink{
          ...,
          ${contactSupportImageProjection},
          bynderImage,
          link{
            ...,
            "url": ${internalReferenceUrl},
          }
        },
        contactInfo[]{
          title,
          icon,
          textLink{
            text,
            isBold,
            link
          }
        },
        ctaButtons[]{
          ...,
          link {
            ...,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(isOpenInNewTab, newTab)
          }
        }
      }
    )
  }
`;

export const CONTACT_SUPPORT_BY_PAGE_QUERY = `
  *[_type == $pageType && ((defined(slug.current) && slug.current == $slug) || (defined(type) && type == $slug))][0]{
    isIncludedContactSupport,
    "contactSupport": select(
      isIncludedContactSupport => *[_type == "${contactSupportType}"][0]{
        ...,
        imageLink{
          ...,
          ${contactSupportImageProjection},
          bynderImage,
          link{
            ...,
            "url": ${internalReferenceUrl},
          }
        },
        contactInfo[]{
          title,
          icon,
          textLink{
            text,
            isBold,
            link
          }
        },
        ctaButton{
          ...,
          link{
            ...,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(isOpenInNewTab, newTab)
          }
        }
      }
    )
  }
`;
